import React, { useEffect, useState, useCallback, forwardRef } from "react";
// import EditEntity from "./components/EditEntity";
// import EditPerson from "./components/EditPerson";
// import ConsultOperation from "./components/ConsultOperation";
import EditUser from "./components/EditUser";
import { hasAccessToDashboard } from "~/api";
import { useHistory } from 'react-router-dom';
import Skeleton from "~/components/Skeleton";
import "react-datepicker/dist/react-datepicker.css";
import "./styles.scss";

const Admin = ({ setError }) => {
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("EditUser");

  useEffect(() => {
    setLoading(true);
    hasAccessToDashboard()
      .then(({ data }) => {
        if (!data.acesso) {
          alert('Você não possui permissão para acessar está página!');
          history.replace('/operations');
        }
        setLoading(false);
      })
      .catch(() => {
        alert('Você não possui permissão para acessar está página!');
        history.replace('/operations');
      });
  }, [history]);

  const tabs = [
    { id: "ConsultOperation", label: "OPERAÇÕES", disabled: true },
    { id: "EditPerson", label: "P. FÍSICAS", disabled: true },
    { id: "EditEntity", label: "P. JURÍDICAS", disabled: true },
    { id: "EditUser", label: "USUÁRIOS" , disabled: false },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "ConsultOperation":
        return <ConsultOperation />;
      case "EditPerson":
        return <EditPerson />;
      case "EditEntity":
        return <EditEntity />;
        case "EditUser":
          return <EditUser />;
      default:
        return <div>Selecione uma aba</div>;
    }
  };

  return (
    <>
      <h1>Admin</h1>
      <div className="container-dash">
        <div className="header-box-button">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => !tab.disabled && setActiveTab(tab.id)}
              className={activeTab === tab.id ? "active" : ""}
            >
              {tab.label}
            </button>
          ))}
        </div>
        <div className="content-box">
          {loading &&
              Array.from(new Array(8)).map((_, index) => (
                <Skeleton key={index} width="calc(100% - 12px)" ml={12} />
              ))}
          {!loading ? (renderContent()) : null }
        </div>
      </div>
    </>
  );
};

export default Admin;
